import { render } from "./AiChatbots.vue?vue&type=template&id=df5c320e&scoped=true"
import script from "./AiChatbots.vue?vue&type=script&lang=js"
export * from "./AiChatbots.vue?vue&type=script&lang=js"

import "./AiChatbots.vue?vue&type=style&index=0&id=df5c320e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df5c320e"]])

export default __exports__